import { type IFio } from '@App/types/authType'

const fioHandler = (fio: IFio, format: 'fullname' | 'lastnameAndInitials' | 'initials'): string => {
    const fullName = `${fio?.fname} ${fio?.iname} ${fio?.oname || ''}`
    const lastnameAndInitials = `${fio?.fname} ${fio?.iname[0]}. ${fio?.oname ? `${fio?.oname[0]}.` : ''}`
    const initials = `${fio?.iname[0]}${fio?.oname ? fio?.oname[0] : ''}`
    switch (format) {
        case 'initials':
            return initials
        case 'fullname':
            return fullName
        case 'lastnameAndInitials':
            return lastnameAndInitials
        default:
            return fullName
    }
}

const isEmptyValue = (value: unknown): value is null | number | undefined | '' | unknown[] =>
    Array.isArray(value) ? value.length === 0 : value === null || value === undefined || value === ''

const toUpperCaseFirstLatter = (string: string) => string.charAt(0).toUpperCase() + string.slice(1)

const formatCurrancy = (value: string | number): string =>
    value.toString().replace(/(\d{1,3}(?=(?:\d\d\d)+(?!\d)))/g, '$1' + ' ')

const onGetPhoneFrontFormat = (phone: string) => {
    const separatedPhoneNumber = phone.replace(/\D/g, '').match(/(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})/)
    if (separatedPhoneNumber) {
        const stateCode = separatedPhoneNumber[1]
        const operatorCode = separatedPhoneNumber[2]
        const firstPart = separatedPhoneNumber[3]
        const secondPart = separatedPhoneNumber[4]
        const thirdPart = separatedPhoneNumber[5]
        return `+${stateCode} (${operatorCode}) ${firstPart}-${secondPart}-${thirdPart}`
    }
    return phone
}

const onGetPhoneBackFormat = (phone: string) => phone.replace(/[^0-9]/g, '')
const onGetPhoneLength = (phone: string) => phone.split('').filter((num) => /^\d+$/.test(num)).length

export default {
    isEmptyValue,
    toUpperCaseFirstLatter,
    formatCurrancy,
    fioHandler,
    onGetPhoneFrontFormat,
    onGetPhoneBackFormat,
    onGetPhoneLength
}
